export const buildNumber = '20260825.3';
export const version = '3.15.0';
export const latestCommit = '6d74046b57ef46f37fe65905535c4779066906ee';
